// Dependecies
import React from 'react';

// Components
import HomeContent from '../components/HomeContent';
import Template from '../components/Template';

function Home(props) {
  return (
    <Template type={1}>
      <HomeContent {...props} />
    </Template>
  );
}

export default Home;
